export default __webpack_public_path__ + "7c6bf8dea2191f41a17c3b2404981a53.png";